export const googleAuthConfig = {
    client_id: '574472089104-tbher5us71us3obvvan9g90ecsuqpmdm.apps.googleusercontent.com',
    redirect_uri_default: 'https://3303.ua',
    redirect_uri_promo:'https://3303.ua/p'
}
